/**
 * ToastComponents.js
 * Talkroute
 *
 * Created by Vel Genov on 6/9/19
 * Copyright (c) 2019 Talkroute. All right reserved.
 */
/* eslint react/prop-types: 0 */

import React, { Children } from "react";
import { TransitionGroup } from "react-transition-group";
import { DefaultToast } from "react-toast-notifications";

/**
 * A custom toast message's body.
 * Extends DefaultToast.
 */
export const CustomToast = ({ children, ...props }) => (
  <div style={{ zIndex: 9999 }}>
    <DefaultToast className={props.disableDismiss ? `react-toast-notifications-dissabled-dismiss react-toast-notifications__toast react-toast-notifications__toast--${props.appearance}` : undefined} { ...(props as any)}>{children}</DefaultToast>
  </div>
);

/**
 * A custom definition of a toast container. Specifies a zIndex of 9999
 * to ensure it's displayed above all other components
 */
export const Container = ({ children, placement }) => (
  <div
    style={{
      boxSizing: "border-box",
      maxHeight: "100%",
      overflowX: "hidden",
      overflowY: "hidden",
      padding: 8,
      pointerEvents: Children.count(children) ? "auto" : "none",
      position: "fixed",
      zIndex: 9999,
      ...placements[placement],
    }}
  >
    <TransitionGroup component={null}>{children}</TransitionGroup>
  </div>
);

/**
 * Different pre-difined positions for displaying toasts
 */
const placements = {
  "top-left": { top: 0, left: 0 },
  "top-center": { top: 0, left: "50%", transform: "translateX(-50%)" },
  "top-right": { top: 0, right: 0 },
  "bottom-left": { bottom: 0, left: 0 },
  "bottom-center": { bottom: 0, left: "50%", transform: "translateX(-50%)" },
  "bottom-right": { bottom: 0, right: 0 },
};
